import * as yup from "yup";

export const deleteAccountSchema = yup.object().shape({
    delete: yup.string().required("Field is required"),
});
